// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostCompanysLoginVerificationBody, BaseResponseVoid } from '../../types';

/**
 * 修改/新增二次验证
 *
 * @export
 * @tags 租户接口
 * @link [POST] /companys/loginVerification
 */
export function postCompanysLoginVerification(
    data: PostCompanysLoginVerificationBody
): Promise<BaseResponseVoid>;
export function postCompanysLoginVerification(
    data: PostCompanysLoginVerificationBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postCompanysLoginVerification(
    data: PostCompanysLoginVerificationBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostCompanysLoginVerificationBody, never, never>('/companys/loginVerification', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postCompanysLoginVerification',
    });
}

export const meta = [{ tags: ['租户接口'], path: '/companys/loginVerification', method: 'post' }];
